// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import legalCaseDocumentEntity from './entities/legal-case-document.json';
import legalCaseDocumentMenu from '../pages/legal-case-document/menu.json';
import legalCaseDocumentFullForm from '../pages/legal-case-document/forms/full.json';
import legalCaseDocumentContextForm from '../pages/legal-case-document/forms/context.json';
import legalCaseDocumentMiniForm from '../pages/legal-case-document/forms/mini.json';
import legalCaseDocumentLookupForm from '../pages/legal-case-document/forms/lookup.json';
import legalCaseDocumentTableView from '../pages/legal-case-document/views/table.json';
import legalCaseDocumentCardsView from '../pages/legal-case-document/views/cards.json';
import legalCaseDocumentDashboardView from '../pages/legal-case-document/views/dashboard.json';

/** Тип запису «Документ справи» зі сторінками пакета: меню, форми та подання з pages/legal-case-document/. */
export const legalCaseDocumentDefinition: IRecordTypeDefinition = {
  ...legalCaseDocumentEntity,
  views: assembleViewSet({
      table: legalCaseDocumentTableView,
      cards: legalCaseDocumentCardsView,
      dashboard: legalCaseDocumentDashboardView,
  }),
  form: legalCaseDocumentFullForm,
  forms: { full: legalCaseDocumentFullForm, context: legalCaseDocumentContextForm, mini: legalCaseDocumentMiniForm, lookup: legalCaseDocumentLookupForm },
  menu: legalCaseDocumentMenu,
} as IRecordTypeDefinition;
